import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import commonStyles from '../../ConfirmPopup.module.scss';
import styles from './ValidationBlock.module.scss';
import { useValidationBlock } from './useValidationBlock';
import { ValidationBlockProps } from '../../types';
import { TEXTS } from '../../constants';

function ValidationBlock({
  validationBlockTitle,
  validationBlockWarning,
  isVisible,
  onValidationSuccess,
  onValidationFailure,
}: ValidationBlockProps) {
  const { nodeRef, inputRef, isInvalid, isComplete, onInput } = useValidationBlock(
    isVisible,
    onValidationSuccess,
    onValidationFailure,
  );

  useEffect(() => {
    const isTouchDevice =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      !window.matchMedia('(hover: hover)').matches;

    if (inputRef.current && !isTouchDevice) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    if (isComplete && inputRef.current) {
      inputRef.current.disabled = true;
    }
  }, [isComplete, inputRef]);

  return (
    <CSSTransition
      in={isVisible}
      nodeRef={nodeRef}
      timeout={300}
      classNames={{
        enter: commonStyles.popupBackground_enter,
        enterActive: commonStyles.popupBackground_enterActive,
        exitActive: commonStyles.popupBackground_exitActive,
        exit: commonStyles.popupBackground_exit,
      }}
      unmountOnExit
    >
      <div className={styles.validationBlock} ref={nodeRef}>
        <div className={styles.validationBlock_title}>
          {validationBlockTitle ?? TEXTS.VALIDATION.TITLE}
        </div>

        <div className={styles.validationBlock_equation}>
          <div className={styles.validationBlock_equationSvg} />

          <input
            ref={inputRef}
            onInput={onInput}
            className={classNames(
              styles.validationBlock_input,
              isInvalid && styles.validationBlock_input_invalid,
              isComplete && styles.validationBlock_input_complete,
            )}
            type="text"
            inputMode="numeric"
          />
        </div>

        <div className={styles.validationBlock_warning}>
          {validationBlockWarning ?? TEXTS.VALIDATION.DEFAULT_WARNING}
        </div>
      </div>
    </CSSTransition>
  );
}

export { ValidationBlock };
